<template>
  <div class="msg">
    <common-head title="消息中心" />
    <van-pull-refresh
      class="pull"
      v-model="isLoading"
      success-text="刷新完成"
      @refresh="onRefresh"
    >
      <van-tabs v-model="active" background="transparent" @click="tab">
          <van-tab title="预约通知" name="1"></van-tab>
          <van-tab title="系统通知" name='2' v-if="msgSys>0" :badge="msgSys"></van-tab>
          <van-tab title="系统通知" name='2' v-else></van-tab>
        <van-tab title="全部" name='0' v-if="count>0" :badge="count"></van-tab>
          <van-tab title="全部" name='0' v-else></van-tab>
      </van-tabs>
  
       <div class="my-wrap">
        <div class="my-card" @click="showDialog(item.bizType,item.sender,item.bizId)"  v-for='(item,index) in noticeData' :key="index">
          <img :src="item.messageType == 1 ? message : system">
          <div class="text">
            <div class="header">
              <span class="left" v-if="item.messageType==1">预约通知</span>
              <span class="left" v-if="item.messageType==2">系统通知</span>
              <span class="right">{{formatData(item.createTime)}}</span>
            </div>
            <div class="my-html" v-html="item.context">
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <van-dialog v-model="isShow" title="标题" show-cancel-button confirmButtonText="同意" cancelButtonText="拒绝" @confirm="agree" @cancel="disagree">
      <div class="dialog-cont">
        你好，{{sender}}请求添加您为家庭成员，请确认是否允许对方添加？
      </div>
      <div class="bottom">
        添加后您作为{{sender}}的家庭成员，{{sender}}可为您预约疫苗
      </div>
    </van-dialog>
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import {msgCebter,msgCount,agree,disagree} from 'api/home'
import moment from 'moment'
import head from 'components/SearchHead'
import { mapState } from 'vuex'

export default {
  components: {
    CommonHead
  },
  computed: {
    ...mapState(['loading']),
  },
  watch: {
    loading(value) {
      if (!value) {
        this.isLoading = false
      }
    }
  },
  data() {
    return {
      message: require('@/assets/imgs/message.png'),
      system: require('@/assets/imgs/system.png'),
      isLoading: false,
      isShow: false,
      active: 1,
      noticeData: [],
      msgSys: 0,
      count: 0,
      sender: '',
      bizId: ''
    }
  },
  created() {
    this.getMsg()
  },
  methods: {
    tab() {
      this.getMsg()
      if (this.active == 2) {
        this.msgSys == 0
      } else if ( this.active == 0) {
        this.count == 0
      }
    },
    getMsg() {
      msgCebter({messageType:this.active}).then(resp=>{
        if(resp.code == 0){
          this.noticeData = resp.data
          this.noReadCount()
          head.methods.msgCount()
        }
      })
    },
    noReadCount() {
      msgCount().then(resp => {
        this.msgSys = resp.data.systemCount
        this.count = resp.data.allCount
      })
    },
    showDialog(bizType,sender,bizId) {
      if (bizType == 10) {
        this.isShow = true
        this.sender = sender
        this.bizId = bizId
      }
    },
    agree() {
      agree({id:this.bizId}).then(resp=>{
        if (resp.code == 0) {
          this.getMsg()
        }
      })
    },
    disagree() {
      disagree({id:this.bizId}).then(resp=>{
        this.getMsg()
      })
    },
    formatData(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    onRefresh() {
      this.getMsg()
    }
  }
}
</script>

<style lang="less" scoped>
.pull {
  min-height: calc(100vh - 97px);
}
// .van-tab__text--ellipsis{
//     width: 40px;
//     height: 40px;
//     background: #f2f3f5;
//     border-radius: 4px;
//   }
.my-card {
  display: flex;
  margin-bottom: 13px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 45px;
    height: 45px;
    margin-right: 10px;
  }
  .text {
    flex: 1;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      .left {
        font-weight: 500;
      }
      .right {
        font-size: 12px;
        color: #ccc;
        font-weight: 500;
      }
    }
    .my-html {
      font-size: 12px;
      color: var(--grey);
    }
  }
}
.dialog-cont {
  padding: 5px 20px;
  font-size: 14px;
}
</style>